import { isTcEnabledULX } from '../ExperimentsUtil';
import ExperimentUtil from '../ExperimentUtil';
import log from '../ClientLogger';

// Define the main event list object first
const tcEventsList = {};

// Helper function to handle event triggering
const triggerTagCommanderEvent = (eventName, payloadBuilder, payloadData) => {
    try {
        // eslint-disable-next-line no-underscore-dangle
        const initialState = window.__INITIAL_STATE__;
        const experimentUtil = new ExperimentUtil(initialState.app.experiments);

        if (isTcEnabledULX(experimentUtil)) {
            const tcEvent = window?.tC?.event?.[eventName];
            if (tcEvent) {
                // Pass `tcEventsList` directly as the context
                tcEvent(tcEventsList, payloadBuilder(payloadData));
            } else {
                log('warning', {
                    category: 'TagCommander',
                    event: `${eventName} script not loaded`
                });
            }
        } else {
            log('info', {
                category: 'TagCommander',
                event: 'TagCommander is disabled'
            });
        }
    } catch (e) {
        log('error', {
            category: 'TagCommander',
            event: `Error in ${eventName}`,
            error: e
        });
    }
};

// Payload builder functions
const buildUserAccountCreatedPayload = triggerPayload => ({
    event_loginsource: triggerPayload?.loginsource,
    event_logintype: triggerPayload?.logintype,
    event_newusertype: triggerPayload?.newusertype,
    event_publicuuid: triggerPayload?.publicuuid
});

const buildPageviewPayload = pageName => ({
    event_pagename: pageName
});

// Define methods within `tcEventsList`
tcEventsList.userAccountCreated = function userAccountCreated(triggerPayload) {
    triggerTagCommanderEvent('userAccountCreated', buildUserAccountCreatedPayload, triggerPayload);
};

tcEventsList.pageview = function pageview(pageName) {
    triggerTagCommanderEvent('pageview', buildPageviewPayload, pageName);
};

export default tcEventsList;
